ui.popup = function(){

	/**
	 * Crea un mensaje de alerta con botón de ok
	 * @param string htmlMensaje Mensaje a mostrar
	 * @param function funcionOk Función a ejecutar al pulsar sobre "ok" (opcional)
	 * @param string claseCss Clase css adicional para el popup
	 * @return jQuery Popup recién creado
	 */
	function crearAlerta(htmlMensaje,funcionOk,claseCss){
		var bloque = $("<div />");
		var mensaje = $("<div />");
		bloque.addClass("c");
		mensaje.addClass("mensaje");
		//si nos pasan Array lo convertimos a UL
		if($.isArray(htmlMensaje)){
			if($.isPlainObject(htmlMensaje[0])){
				var msgs = [];
				for(var i in htmlMensaje)
					msgs.push(htmlMensaje[i].mensaje);
				htmlMensaje = msgs;
			}
			htmlMensaje = "<ul><li>"+htmlMensaje.join("</li><li>")+"</li><ul>";
		}
		mensaje.html(htmlMensaje);
		var botones = crearBotones("btnsAccion");
		bloque.append(mensaje);
		bloque.append(botones);
		var popup = crear(bloque,"popupAlerta"+(claseCss?" "+claseCss:""));
		botones.append(
			crearBoton(
				i18next ? i18next.t('NBF_ALERTA_ACEPTAR') : '<?php return \datos\txt::v("NBF_ALERTA_ACEPTAR"); ?>', // TODO: Eliminar php cuando todos los 3.5 estén con webpack
				"Ok",
				function(){
					ocultar(popup);
					if(funcionOk)
						funcionOk();
				}
			)
		);
		//damos foco al botón
		botones.find(".btn a").focus();
		return popup;
	}

	/**
	 * Crea un mensaje de alerta de error con botón de ok
	 * @param string htmlMensaje Mensaje a mostrar
	 * @param function funcionOk Función a ejecutar al pulsar sobre "ok" (opcional)
	 * @return jQuery Popup recién creado
	 */
	function crearAlertaError(htmlMensaje,funcionOk){
		return crearAlerta(htmlMensaje,funcionOk,"popupAlertaError");
	}

	/**
	 * Crea un mensaje de alerta de advertencia con botón de ok
	 * @param string htmlMensaje Mensaje a mostrar
	 * @param function funcionOk Función a ejecutar al pulsar sobre "ok" (opcional)
	 * @return jQuery Popup recién creado
	 */
	function crearAlertaAdvertencia(htmlMensaje,funcionOk){
		return crearAlerta(htmlMensaje,funcionOk,"popupAlertaAdvertencia");
	}

	/**
	 * Crea un mensaje de alerta ok con botón de ok
	 * @param string htmlMensaje Mensaje a mostrar
	 * @param function funcionOk Función a ejecutar al pulsar sobre "ok" (opcional)
	 * @return jQuery Popup recién creado
	 */
	function crearAlertaOk(htmlMensaje,funcionOk){
		return crearAlerta(htmlMensaje,funcionOk,"popupAlertaOk");
	}

	/**
	 * Crea un mensaje de alerta basándose en el objeto \nbf\Respuesta pasado
	 * @param object respuesta Respuesta obtenida (objeto \nbf\Respueta)
	 * @param function funcionOk Función a ejecutar al pulsar sobre "ok" (opcional)
	 * @return jQuery Popup recién creado
	 */
	function crearAlertaRespuesta(respuesta,funcionOk){
		var funcion = crearAlertaError;
		if(respuesta.status=="ok")
			funcion = crearAlertaOk;

		if(respuesta.mensajes)
			return funcion(respuesta.mensajes,funcionOk);
		else if(respuesta.mensaje)
			return funcion(respuesta.mensaje,funcionOk);
		else if(respuesta)
			return funcion(respuesta,funcionOk);
	}

	/**
	 * Crea un mensaje de confirmación con opciones si/no
	 * @param string htmlMensaje Mensaje a mostrar
	 * @param function funcionSi Función a ejecutar al pulsar sobre "si"
	 * @param function funcionNo Función a ejecutar al pulsar sobre "no" (opcional)
	 * @param function etiquetaSi Texto del botón sí
	 * @param function etiquetaNo Texto del botón no
	 * @return jQuery Popup recién creado
	 */
	function crearAlertaConfirmar(htmlMensaje,funcionSi,funcionNo,etiquetaSi,etiquetaNo){
		var bloque = $("<div />");
		var mensaje = $("<div />");
		mensaje.addClass("mensaje");
		mensaje.html(htmlMensaje);
		var botones = crearBotones("btnsAccion");
		bloque.append(mensaje);
		bloque.append(botones);
		var popup = crear(bloque,"popupAlerta popupAlertaConfirmar");
		var etiquetaDefectoSi = i18next ? i18next.t('NBF_ALERTA_CONFIRMAR_SI') : '<?php return \datos\txt::v("NBF_ALERTA_CONFIRMAR_SI"); ?>';// TODO: Eliminar php cuando todos los 3.5 estén con webpack
		var etiquetaDefectoNo = i18next ? i18next.t('NBF_ALERTA_CONFIRMAR_NO') : '<?php return \datos\txt::v("NBF_ALERTA_CONFIRMAR_NO"); ?>';// TODO: Eliminar php cuando todos los 3.5 estén con webpack
		botones.append(
			crearBoton(
				etiquetaSi ? etiquetaSi : etiquetaDefectoSi,
				"Si",
				function(){
					ocultar(popup);
					funcionSi();
				}
			)
		);
		botones.append(
			crearBoton(
				etiquetaNo ? etiquetaNo : etiquetaDefectoNo,
				"No",
				function(){
					if(funcionNo)
						funcionNo();
					else
						ocultar(popup);
				}
			)
		);
		return popup;
	}

	/**
	 * Crea un mensaje de confirmación con opciones si/no
	 * @param string htmlMensaje Mensaje a mostrar
	 * @param array opciones Lista de objetos con atributos "texto", "css" y "funcion"
	 * @return jQuery Popup recién creado
	 */
	function crearOpciones(htmlMensaje,opciones){
		var bloque = $("<div />");
		var mensaje = $("<div />");
		mensaje.addClass("mensaje");
		mensaje.html(htmlMensaje);
		var botones = crearBotones("btnsAccion");
		bloque.append(mensaje);
		bloque.append(botones);
		var popup = crear(bloque,"popupOpciones");
		for(var i=0;i<opciones.length;i++){
			botones.append(
				crearBoton(
					opciones[i].texto,
					opciones[i].css,
					opciones[i].funcion
				)
			);
		}
		return popup;
	}

	/**
	 * Crea un conjunto de botones para popup
	 */
	function crearBotones(claseCss){
		var botones = $("<div />");
		botones.addClass("btns");
		if(claseCss)
			botones.addClass(claseCss);
		return botones;
	}

	/**
	 * Crea un boton para popup
	 */
	function crearBoton(etiqueta,tipo,funcionClick){
		var btn = $('<span />');
		btn.addClass("btn btn"+tipo);
		btn.html('<a href="#"><em>'+etiqueta+'</em></a>');
		btn.find("a").click(
			function(ev){
				ev.preventDefault();
				ev.stopPropagation();
				funcionClick(ev,$(this));
			}
		);
		return btn;
	}

	/**
	 * Previsualiza la imagen pasada en un popup
	 * @param string URL de la imagen
	 */
	function crearImagen(urlImagen,claseCss){
		var img = $("<img />");
		img.attr("src",urlImagen);
		img.load(
			function(){
				if($(this).width()>$(window).width())
					$(this).attr("width",$(window).width()-100);
				else if($(this).height()>$(window).height())
					$(this).attr("height",$(window).height()-100);
				var p = $(this).closest(".popupImagen");
				p.css("position","absolute");
				p.css("top",$(window).scrollTop()+20);
				p.css("left","50%");
				p.css("margin","0 0 0 -"+parseInt(p.width()/2)+"px");
				$(this).click(
					function(){
						ocultar(p);
					}
				);
			}
		);
		return crear(img,"popupImagen"+(claseCss?" "+claseCss:""));
	}

	/**
	 * Previsualiza una URL en una ventana mediante un iframe. Devuelve el id de la ventana creada
	 * @param string url URL a abrir
	 * @param string claseCss Clase CSS a aplicar sobre la ventana
	 * @return string Id de la ventana recien creada
	 */
	function crearUrl(url,claseCss){
	    var bloque = $("<div />");
	    var cargando = $("<div />");
	    cargando.addClass("cargando");
	    var iframe = $("<iframe />");
	    iframe.attr("frameBorder",0);
	    bloque.append(cargando);
	    bloque.append(iframe);
	    iframe.load(
	    	function(){
	    		cargando.remove();
	    	}
	    );
	    iframe.attr("src",url);
	    return crear(bloque,claseCss);
	}

	/**
	 * Muestra un popup con el código HTML pasado
	 * @param string htmlInterno HTML interior
	 * @param string claseCss Clase CSS a aplicar al div exterior
	 */
	function crearHtml(htmlInterno,claseCss){
	    return crear($(htmlInterno),claseCss);
	}

	/**
	 * Muestra un popup con el nodo pasado
	 * @param jQuery jq Nodo DOM a incluir
	 * @param string claseCss Clase CSS a aplicar al div exterior
	 * @return string Id de la ventana recien creada
	 */
	function crear(jq,claseCss){
		var popup = $("<div />");
	    popup.addClass("popup");
	    popup.addClass(claseCss);

	    var popupContent = $("<div />");
	    popupContent.addClass("popupContent");

	    var botones = crearBotones("btnsNav");
	    var btnCerrar = $("<a />");
	    btnCerrar.attr("href","#");
	    btnCerrar.html(i18next ? i18next.t('NBF_SELECTOR_CERRAR') : "<?php return txt('NBF_SELECTOR_CERRAR'); ?>");// TODO: Eliminar php cuando todos los 3.5 estén con webpack
	    btnCerrar.addClass("btn btnCerrar");
		btnCerrar.click(
	    	function(ev){
	    		ev.preventDefault();
	    		ocultar(popup);
	    	}
	    );
	    botones.append(btnCerrar);
	    popup.append(popupContent);
	    popupContent.append(botones);
	    popupContent.append(jq);
		ui.init(popup);

		var frame = ui.crearPopFrame(false);
		frame.append(popup);
	    return popup;
	}

	/**
	 * Oculta/elimina un popup Jq
	 * @param jQuery jq Nodo jQuery a ocultar
	 */
	function ocultar(jq){
		ui.ocultarPopFrame(jq.closest(".popFrame"));
	}

	/**
	 * Obtiene el popup al que pertenece el elemento pasado
	 * @param jQuery jq Elemento perteneciente a popup
	 * @return jQuery Popup al que pertenece
	 */
	 function obtenerPopup(jq){
		if(jq.hasClass("popup"))
			return jq;
		else
			return jq.closest(".popup").eq(0);
	}

	return {
		"crearAlerta":crearAlerta,
		"crearAlertaError":crearAlertaError,
		"crearAlertaAdvertencia":crearAlertaAdvertencia,
		"crearAlertaOk":crearAlertaOk,
		"crearAlertaRespuesta":crearAlertaRespuesta,
		"crearAlertaConfirmar":crearAlertaConfirmar,
		"crearOpciones":crearOpciones,
		"crearBotones":crearBotones,
		"crearBoton":crearBoton,
		"crearImagen":crearImagen,
		"crearUrl":crearUrl,
		"crearHtml":crearHtml,
		"crear":crear,
		"ocultar":ocultar,
		"obtenerPopup":obtenerPopup
	}
}();

